<template>
	<div class="billing">
		<TableFilters
			placeholder="Search by uuid..."
			:controls="controls"
			:filters="filters" />
		<div class="billing__section">
			<h2 class="billing__section-title">Token Batches</h2>
			<TokenBatchesTable
				:route-name="props.routeName"
				:route-params="props.routeParams"
				:search="filters.search"
				:user-id="props.userId" />
		</div>

		<div class="billing__section">
			<h2 class="billing__section-title">Token Usage History</h2>
			<TokenUsageEventsTable
				:route-name="props.routeName"
				:route-params="props.routeParams"
				:search="filters.search"
				:user-id="props.userId" />
		</div>
	</div>
</template>

<script setup lang="ts">
import TokenBatchesTable from './Usage/TokenBatchesTable.vue'
import TokenUsageEventsTable from './Usage/TokenUsageEventsTable.vue'
import TableFilters from '@/components/filters/TableFilters.vue'
import { watch, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Filters } from '@/helpers/filters/Filters'
import { FilterControls } from '@/helpers/filters/FilterControls'

const props = withDefaults(
	defineProps<{
		routeName?: string
		routeParams?: Record<string, string | number>
		userId?: number
	}>(),
	{
		routeName: 'account-details',
		routeParams: () => ({}),
		userId: undefined,
	},
)

const emit = defineEmits<{
	(e: 'update:search', value: string): void
}>()

const route = useRoute()

const controls = new FilterControls([])
const filters = ref(Filters.fromQuery(route.query as any, controls))

watch(
	() => route.query.s,
	async (val) => {
		filters.value.search = typeof val === 'string' ? val : ''
	},
	{ immediate: true },
)

watch(
	() => filters.value.search,
	(val, prev) => {
		if (val === prev) return
		emit('update:search', val)
	},
)
</script>

<style scoped lang="scss">
.billing {
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;

	& > * {
		width: 100%;
	}

	/* Copied minimal searchbar styles from TableFilters */
	.table-filters {
		display: flex;
		flex-direction: column;
		gap: 8px;

		.table-filters__row {
			display: flex;
			align-items: center;
			gap: 12px;
		}

		.table-filters__search {
			flex: 1;
			position: relative;
			.table-filters__search-icon {
				position: absolute;
				left: 12px;
				top: 50%;
				transform: translateY(-50%);
				color: var(--p-text-secondary);
			}
			.table-filters__search-input {
				width: 100%;
				padding-left: 34px;
			}
			.table-filters__clear {
				position: absolute;
				right: 8px;
				top: 50%;
				transform: translateY(-50%);
				background: transparent;
				border: none;
				color: var(--p-text-secondary);
				cursor: pointer;
				padding: 4px;
			}
		}
	}

	.billing__section {
		display: flex;
		flex-direction: column;
		gap: 16px;

		.billing__section-title {
			font-size: 22px;
			font-weight: 800;
		}
	}
}
</style>
